import { norwegianCountryCodeString } from "./norwegianCountryCode";

export const norwegianAreaMobile = new RegExp(`^(${norwegianCountryCodeString})(\\d{8})$`);
